// form validation
(function () {
  const form = '.js-form';
  const $submit = jQuery('.js-submit');
  const $privacy = jQuery('.js-privacy');
  let requireFlg = false;
  let privacyFlg = false;
  let $require = jQuery(`${form} [required]`);
  let fillCount = 0;

  function setSubmitProp() {
    if (requireFlg && privacyFlg) {
      $submit.prop('disabled', false);
    } else {
      $submit.prop('disabled', true);
    }
  }

  jQuery('.js-formTel').on('blur', function () {
    let val = jQuery(this).val().replace(/[━.‐.―.－.-.ー.-]/gi, '');
    if (!val.match(/^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/)) {
      jQuery(this).val('');
      alert('電話番号が正しくありません');
    }
  });

  // 必須項目
  $require.on('blur', function () {
    // if (jQuery(this).attr('id') === 'js-formKana' && !jQuery(this).val().match(/^([ァ-ン]|ー)+$/)) {
    if (jQuery(this).hasClass('js-formKana') && !jQuery(this).val().match(/^([ァ-ン　 ]|ー)+$/)) {
      jQuery(this).val('');
      alert('全角カタカナで入力してください。');
    }
    if (jQuery(this).attr('name') == 'your_email' && !jQuery(this).val().match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)) {
      jQuery(this).val('');
      alert('メールアドレスが正しくありません');
    }
  });

  $require.on('keyup', function () {
    $require.each(function () {
      let value = jQuery(this).val();

      if ((value !== '' && value.match(/[^\s\t]/))) {
        fillCount++;
      }
    });

    requireFlg = (fillCount === $require.length ? true : false);

    setSubmitProp();
    fillCount = 0;
  });

  // プライバシーポリシー
  $privacy.on('change', function () {
    privacyFlg = (jQuery(this).prop('checked') ? true : false);
    setSubmitProp();
  });

  // 送信時
  jQuery(form).on('submit', function () {
    if (!(requireFlg && privacyFlg)) {
      alert('入力に誤りがあります。');
      return false;
    }
  });
})();

// });


document.addEventListener('wpcf7mailsent', function(event) {
  const formEl = event.target;
  if (!(formEl instanceof HTMLFormElement)) return;

  if (formEl.closest('.p-contact-consultation__form')) {
    location.href = '/consultation-thanks/';
    return;
  }

  if (formEl.closest('.p-compe-contact__form')) {
    location.href = '/compe-thanks/';
  }
}, false);

/**
 * お問い合わせ select：未選択はプレースホルダー色、選択後は入力文字色
 */
function initContactFormSelectStyle(formSelector, selectClass, filledClass, dataAttr) {
  const root = document.querySelector(formSelector);
  if (!root || root.dataset[dataAttr] === 'true') return;

  root.dataset[dataAttr] = 'true';

  const syncSelect = (select) => {
    if (!select.classList.contains(selectClass)) return;

    select.classList.toggle(filledClass, select.value !== '');
  };

  root.querySelectorAll(`.${selectClass}`).forEach(syncSelect);

  root.addEventListener('change', (event) => {
    const target = event.target;

    if (target instanceof HTMLSelectElement && target.classList.contains(selectClass)) {
      syncSelect(target);
    }
  });
}

function initContactSelectStyles() {
  initContactFormSelectStyle(
    '.p-contact-consultation__form',
    'p-contact-consultation__select',
    'p-contact-consultation__select--filled',
    'consultationSelectStyleInit'
  );
  initContactFormSelectStyle(
    '.p-contact-inquiry__form',
    'p-contact-inquiry__select',
    'p-contact-inquiry__select--filled',
    'inquirySelectStyleInit'
  );
}

document.addEventListener('DOMContentLoaded', initContactSelectStyles);
document.addEventListener('wpcf7domready', initContactSelectStyles);

/**
 * CF7：各フィールドのエラーが解消されたら、送信ボタン下の全体メッセージを非表示にする
 */
const CF7_FORM_ERROR_CLASSES = ['invalid', 'unaccepted', 'failed', 'aborted'];

function hasCf7FieldErrors(form) {
  if (form.querySelector('.wpcf7-not-valid')) return true;

  return Array.from(form.querySelectorAll('.wpcf7-not-valid-tip')).some((tip) => {
    return tip.textContent.trim() !== '';
  });
}

function clearCf7FormResponseIfValid(form) {
  if (!(form instanceof HTMLFormElement) || !form.classList.contains('wpcf7-form')) return;
  if (form.classList.contains('submitting')) return;

  const hasErrorState = CF7_FORM_ERROR_CLASSES.some((name) => form.classList.contains(name));
  if (!hasErrorState || hasCf7FieldErrors(form)) return;

  const output = form.querySelector('.wpcf7-response-output');
  if (output) {
    output.textContent = '';
    output.setAttribute('aria-hidden', 'true');
  }

  CF7_FORM_ERROR_CLASSES.forEach((name) => form.classList.remove(name));
  form.classList.add('init');
}

function handleCf7FieldUpdateForResponseClear(event) {
  const form = event.target.closest('.wpcf7-form');
  if (!form) return;

  window.requestAnimationFrame(() => clearCf7FormResponseIfValid(form));
}

function initCf7ClearFormResponse() {
  if (document.documentElement.dataset.cf7ResponseClearInit === 'true') return;

  document.documentElement.dataset.cf7ResponseClearInit = 'true';
  document.addEventListener('input', handleCf7FieldUpdateForResponseClear, true);
  document.addEventListener('change', handleCf7FieldUpdateForResponseClear, true);
}

document.addEventListener('DOMContentLoaded', initCf7ClearFormResponse);
document.addEventListener('wpcf7domready', initCf7ClearFormResponse);